import { z } from "zod";

export const addDocumentationSchema = z.object({
  scopeNoteText: z.string(),
  workAfterHours: z.boolean(),
  docusketchLink: z.string(),
});

export type AddDocumentationFormData = z.infer<typeof addDocumentationSchema>;
